import { userAgent } from "@Core/utils/UserAgent";
import { ConnextUserAgent } from "@Core/utils/ConnextUserAgent";
export class BrowserDetectionQualifier {
    constructor() {
        this.key = "BrowserDetection";
    }
    process() {
        let detected = userAgent.getBrowser();
        if (detected === "Internet Explorer")
            detected = ConnextUserAgent.BrowserTypes.IE;
        const knownBrowsers = Object.values(ConnextUserAgent.BrowserTypes);
        return knownBrowsers.includes(detected)
            ? detected
            : ConnextUserAgent.BrowserTypes.unknown;
    }
}
